export const fieldName = 'reassignReferencesToCode';
export const codeId = 'codeId';
export const softConnectionViolation = '_SoftConnectionViolation';
export const keyCombinationViolation = '_KeyCombinationViolation';
export const referenceRegularExpressionType = 2;

export enum CodetableWithCategoryIds {
  ConsequenceLikelihood = 279,
  ConsequenceRecurrence = 278,
  ConsequenceSeverity = 277,
  Reference = 38,
  InteractionOption = 444,
  ReferenceOption = 446
}
